/*
  Abre los menus desplegables del header al pasar el cursor, no al hacer clic.
  Solo en dispositivos con puntero real: en tactiles se mantiene el clic,
  que es el unico gesto disponible.
*/
(function () {
  var puedeHover =
    window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
    window.matchMedia('(min-width: 990px)').matches;

  if (!puedeHover) return;

  var RETARDO_CIERRE = 180;

  document.querySelectorAll('.header__inline-menu details.mega-menu').forEach(function (detalle) {
    var temporizador;

    function abrir() {
      clearTimeout(temporizador);
      document.querySelectorAll('.header__inline-menu details[open]').forEach(function (otro) {
        if (otro !== detalle) otro.removeAttribute('open');
      });
      detalle.setAttribute('open', '');
    }

    function cerrar() {
      temporizador = setTimeout(function () {
        detalle.removeAttribute('open');
      }, RETARDO_CIERRE);
    }

    detalle.addEventListener('mouseenter', abrir);
    detalle.addEventListener('mouseleave', cerrar);
    detalle.addEventListener('focusin', abrir);

    // Con el menu ya abierto por hover, el clic en el titulo lo cerraria;
    // lo dejamos abierto para que el usuario alcance los enlaces.
    var titulo = detalle.querySelector('summary');
    if (titulo) {
      titulo.addEventListener('click', function (evento) {
        if (detalle.hasAttribute('open')) evento.preventDefault();
      });
    }
  });

  // Escape cierra lo que este abierto
  document.addEventListener('keydown', function (evento) {
    if (evento.key !== 'Escape') return;
    document.querySelectorAll('.header__inline-menu details[open]').forEach(function (d) {
      d.removeAttribute('open');
    });
  });
})();
